import { StateService } from './../../../services/state.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { Ticket } from 'sharedTypes/client';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-tickets',
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.scss'],
    standalone: false,
})
export class TicketsComponent implements OnInit, OnDestroy {
    waitForTicketNoSub: Subscription = new Subscription();
    sub: Subscription = new Subscription();
    @Input() filter: string = '';
    aktfilter: string = 'open';
    showDevTickets = 'hide';
    maId = '';
    colorFilter = '';
    shownTickets: Array<Ticket> = [];
    unfilteredTickets: Array<Ticket> = [];

    constructor(
        private firebaseService: FirebaseService,
        private stateService: StateService,
        private authService: AuthService,
        public glo: GlobalService,
        private router: Router,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
    ) {}

    async ngOnInit() {
        if (
            this.authService.getUid() === '8fvmgFqaYYPbAe9pMnQHt3lGm7r2' ||
            this.authService.getUid() === 'tsjG4JomlDXMS5cPExeDnNr01462'
        ) {
            this.authService.logout();
            return;
        }
        if (this.sub) {
            this.sub.unsubscribe();
        }
        const searchkey = this.stateService.searchKey.getValue();
        if (searchkey.validUntil < Date.now()) {
            await this.stateService.getAlgoliaKey();
        }
        if (this.filter) {
            this.aktfilter = this.filter;
        }
        if (this.route?.snapshot?.data) {
            if (this.route.snapshot.data.my) {
                this.aktfilter = 'my';
            }
            if (this.route.snapshot.data.bookmarked) {
                this.aktfilter = 'bookmarked';
            }
            if (this.route.snapshot.data.closed) {
                this.aktfilter = 'closed';
            }
        }
        if (this.aktfilter === 'my') {
            this.sub = this.firebaseService.getMyOpenTickets().subscribe((unfilteredTickets) => {
                this.unfilteredTickets = unfilteredTickets;
                this.filterTickets();
            });
        }
        if (this.aktfilter === 'open') {
            this.sub = this.firebaseService.getOpenTickets().subscribe((unfilteredTickets) => {
                this.unfilteredTickets = unfilteredTickets;
                this.filterTickets();
            });
        }
        if (this.aktfilter === 'bookmarked') {
            this.sub = this.firebaseService.getBookmarkedTickets().subscribe((unfilteredTickets) => {
                this.unfilteredTickets = unfilteredTickets;
                this.filterTickets();
            });
        }
        if (this.aktfilter === 'closed') {
            this.sub = this.firebaseService.getClosedTickets().subscribe((unfilteredTickets) => {
                this.unfilteredTickets = unfilteredTickets;
                this.filterTickets();
            });
        }
    }

    filterTickets() {
        this.shownTickets = this.unfilteredTickets
            .filter((ticket) => {
                if (!this.showDevTickets) {
                    return true;
                }
                if (this.showDevTickets === 'hide') {
                    return !ticket.jiraId;
                }
                if (this.showDevTickets === 'only') {
                    return ticket.jiraId;
                }
                return false;
            })
            .filter((ticket) => {
                if (!this.colorFilter) {
                    return true;
                }
                if (this.colorFilter) {
                    if (ticket.color === this.colorFilter) {
                        return true;
                    }
                }
                return false;
            })
            .filter((ticket) => {
                if (!this.maId) {
                    return true;
                }
                if (this.maId) {
                    if (ticket.assignedTo === this.maId) {
                        return true;
                    }
                }
                return false;
            })
            .sort((a, b) => {
                let aUpdate = a.createdAtUnix;
                if (a.updatedBySupportAtUnix > aUpdate) {
                    aUpdate = a.updatedBySupportAtUnix;
                }
                if (a.updatedAtUnix > aUpdate) {
                    aUpdate = a.updatedAtUnix;
                }
                let bUpdate = b.createdAtUnix;
                if (b.updatedBySupportAtUnix > bUpdate) {
                    bUpdate = b.updatedBySupportAtUnix;
                }
                if (b.updatedAtUnix > bUpdate) {
                    bUpdate = b.updatedAtUnix;
                }
                if (aUpdate > bUpdate) {
                    return -1;
                }
                if (aUpdate < bUpdate) {
                    return 1;
                }

                return 0;
            });
        
        // Trigger change detection to update the count in the header
        this.cdr.detectChanges();
    }
    async newTicket() {
        this.glo.startLoading('Lege Ticket an...');
        const neuesTicketId = await this.firebaseService.createNewTicket({});
        this.waitForTicketNoSub = this.firebaseService.getTicket(neuesTicketId).subscribe((ticket) => {
            if (ticket && ticket.ticketNo) {
                this.waitForTicketNoSub.unsubscribe();
                this.glo.endLoading();
                this.openTicket(ticket.ticketId);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.waitForTicketNoSub) {
            this.waitForTicketNoSub.unsubscribe();
        }
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    openTicket(ticketId: string) {
        this.router.navigate(['/tickets/show/' + ticketId]);
    }
}
